var Timeline = function () {
  this.sequences = [];

  this.end = function() {
    console.log("That's all, folks!");
  };
};

/**
 * Runs through the Sequence Queue synchronously
 * @param  {Number} index Index of the Sequence that you would like to start at.
 *                        Defaults to 0.
 * @return {undefined}
 */
Timeline.prototype.play = function(index) {
  index = index || 0;

  if (index === this.sequences.length) {
    this.end();
    return;
  }

  var self = this;
  var sequence = this.sequences[index];

  sequence()
    .then(function (result) {
      self.play(++index);
    })
    .catch(function (err) {
      console.log(err.name + ": " + err.message);
    });
};

/**
 * Receives a function and adds it to the sequence queue
 * @param {Function} sequence A function that returns a promise.
 */
Timeline.prototype.addSequence = function (sequence) {
  if (typeof sequence === "function") {
    this.sequences.push(sequence);
  } else {
    throw new Error("Timeline.addSequence expects a function.");
  }
};

/**
 * Receives an array of functions and pushes those to the Sequence Queue
 * @param {Array} sequeneces An array of functions that return a promise.
 * @return {undefined}
 */
Timeline.prototype.addSequences = function (sequences) {
  if (!Array.isArray(sequences)) {
    this.addSequence(sequences);
    return;
  }

  var self = this;

  sequences.forEach(function (sequence) {
    self.addSequence(sequence)
  });
};

module.exports = Timeline;
